export const UPDATE_POPUP_CLOSED = 'UPDATE_POPUP_CLOSED'

export const mutations = {
  [UPDATE_POPUP_CLOSED]: function(state) {
    state.popupClosed = true
  },
}
